<template>
  <div
    class="tangram-video-wrap"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
  >
    <div
      v-if="module.detail.video"
      id="tangram-video"
      v-tangram-expose="module.detail.tickerInfo"
      class="tangram-video"
    >
      <div
        v-if="playStatus !== 'play'"
        class="tangram-video-status"
        @click="statusChange('click')"
      >
        <img
          v-if="playStatus === 'stalled'"
          src="@/images/loading/loading.gif"
          alt=""
        />
        <img v-else src="@/images/cms/goods/promote_tags/play.png" alt="" />
        <span>点击播放视频</span>
      </div>

      <video
        id="myVideo"
        ref="myVideo"
        :src="module.detail.video"
        class="tangram-video-player"
        webkit-playsinline="true"
        playsinline="true"
        :custom-status="playStatus"
        :poster="
          module.detail.video + '?x-oss-process=video/snapshot,t_1000,f_jpg'
        "
        @click="statusChange('click')"
      ></video>
    </div>
  </div>
</template>

<script>
import Matrix from '@mc/matrix-main'
const matrix = new Matrix()
export default {
  name: 'TangramVideo',
  myVideo: null,
  io: null,
  props: {
    module: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      playStatus: 'pause',
      isShowed: false
    }
  },
  destroyed() {
    this.io?.disconnect()
  },
  mounted() {
    this.addeventVideo()
    this.observeVideo()
  },
  methods: {
    observeVideo() {
      this.io = new IntersectionObserver(
        ioes => {
          ioes.forEach(ioe => {
            const intersectionRatio = ioe.intersectionRatio
            if (intersectionRatio === 1) {
              this.isShowed = true
              this.player()
            } else {
              if (this.isShowed) {
                this.pause()
              }
            }
          })
        },
        {
          threshold: [0, 1]
        }
      )
      this.io.observe(this.$refs.myVideo)
    },
    addeventVideo() {
      this.$nextTick(() => {
        this.myVideo = this.$refs.myVideo
        ;['pause', 'play', 'ended', 'error', 'stalled'].forEach(item => {
          this.myVideo.addEventListener(
            item,
            () => {
              if (this.myVideo.error?.code === 2 || item === 'error') {
                this.playStatus = 'error'
                this.checkStatus()
                return
              }
              if (item === 'stalled') {
                if (this.playStatus !== 'play') {
                  return
                }
              }
              if (item === 'ended') {
                this.playStatus = 'pause'
                return
              }
              this.playStatus = item
            },
            false
          )
        })
      })
    },
    statusChange(type) {
      if (type === 'click') {
        this.$track(
          this.module.detail.tickerInfo.click.spm,
          this.module.detail.tickerInfo.click.spmJson
        )
      }

      if (this.playStatus === 'pause') {
        this.player()
      } else {
        this.pause()
      }
    },
    checkStatus() {
      if (this.playStatus === 'stalled') {
        this.$toast({
          message: '视频加载中，请稍后',
          duration: '2000'
        })
        return false
      }
      if (this.playStatus === 'error') {
        this.$toast({
          message: '播放失败，请检查网络',
          duration: '2000'
        })
        return false
      }
      return true
    },
    closeOtherPlayer() {
      const videos = document.getElementsByClassName('tangram-video-player')
      for (const key of videos) {
        if (key !== this.myVideo) {
          if (
            !['stalled', 'error'].includes(key.getAttribute('custom-status'))
          ) {
            key.pause()
          }
        }
      }
    },
    player() {
      if (!this.checkStatus()) return
      if (this.playStatus === 'pause') {
        const { isAndroid } = matrix
        if (isAndroid) {
          const isWifi = this.get_status().type_text === 'wifi'
          if (!isWifi) {
            this.$toast({
              message: '当前为非WiFi模式请注意流量消耗',
              duration: '2000'
            })
          }
        }
        this.closeOtherPlayer()
        this.myVideo.play()
      }
    },
    pause() {
      if (!this.checkStatus()) return
      if (this.playStatus === 'play') {
        this.myVideo.pause()
      }
    },
    get_status() {
      const connection = navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection || { tyep: 'unknown' }
      const list = ['unknown', 'ethernet', 'wifi', '2g', '3g', '4g', 'none']
      if (typeof connection.type === 'number') {
        connection.type_text = list[connection.type]
      } else {
        connection.type_text = connection.type
      }
      if (typeof connection.bandwidth === 'number') {
        if (connection.bandwidth > 10) {
          connection.type = 'wifi'
        } else if (connection.bandwidth > 2) {
          connection.type = '3g'
        } else if (connection.bandwidth > 0) {
          connection.type = '2g'
        } else if (connection.bandwidth === 0) {
          connection.type = 'none'
        } else {
          connection.type = 'unknown'
        }
      }
      return {
        connection: connection,
        type_text: connection.type_text,
        bandwidth: connection.bandwidth,
        isOnline: navigator.onLine
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tangram-video {
  position: relative;

  width: 100%;
  height: 4rem;

  &-player {
    width: 100%;
    height: 100%;

    background-color: #000;
  }

  &-status {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.6);

    @include flex(column, center, center);

    img {
      width: 1.2rem;
      height: 1.2rem;
    }
    span {
      margin-top: 0.2rem;

      color: #fff;
    }
  }
  #myVideo {
    width: 100%;
    height: 4rem;
  }
}
</style>
